/** The catch-all entry the API returns for a vehicle brand or model that is not in its list. */
export const VEHICLE_OTHER_MAPPING_NAME = "Ostatné";

export enum EnumerationType {
  TOP_AGENTS = "TOP_AGENTS",
  AGENT_DIRECTORATES = "AGENT_DIRECTORATES",
  AGENT_EDUCATIONS = "AGENT_EDUCATIONS",
  INSTITUTIONS = "INSTITUTIONS",
  PRODUCT_GROUPS = "PRODUCT_GROUPS",
  PRODUCTS = "PRODUCTS",
  AFFILIATE_PARTNERS = "AFFILIATE_PARTNERS",
  VEHICLE_COLORS = "VEHICLE_COLORS",
  COVERAGE_LIMITS = "COVERAGE_LIMITS",
  COMPLICITIES = "COMPLICITIES",
  TARIFF_GROUPS = "TARIFF_GROUPS",
  COMMISSION_SOURCE_TEMPLATES = "COMMISSION_SOURCE_TEMPLATES",
  COMMISSIONS_SETTINGS_LEVELS = "COMMISSIONS_SETTINGS_LEVELS",
  COMMISSIONS_SETTINGS_RANKS = "COMMISSIONS_SETTINGS_RANKS",
  COMMISSIONS_BATCHES = "COMMISSIONS_BATCHES",
  BRANDING = "BRANDING",
  TOP_AGENT_ALLOWED_FEATURES = "TOP_AGENT_ALLOWED_FEATURES",
  CONTRACT_EXTERNAL_VIEW_INSTITUTIONS = "CONTRACT_EXTERNAL_VIEW_INSTITUTIONS",
  PERMISSION_DEFINITIONS = "PERMISSION_DEFINITIONS",
}
